import get from 'lodash.get';
import serverVars from 'server-vars';
import { currencies } from 'dibs-currency-helpers/constants';

const US_COUNTRY_CODE = 'US';

export const affirmSnippet = `
    window._affirm_config = {
        script: "${serverVars.get('config.affirmScriptUrl')}",
        public_api_key: "${serverVars.get('config.affirmPublicKey')}"
    };
    (function(l,g,m,e,a,f,b){var d,c=l[m]||{},h=document.createElement(f),n=document.getElementsByTagName(f)[0],k=function(a,b,c){return function(){a[b]._.push([c,arguments])}};c[e]=k(c,e,"set");d=c[e];c[a]={};c[a]._=[];d._=[];c[a][b]=k(c,a,b);a=0;for(b="set add save post open empty reset on off trigger ready setProduct".split(" ");a<b.length;a++)d[b[a]]=k(c,e,b[a]);a=0;for(b=["get","token","url","items"];a<b.length;a++)d[b[a]]=function(){};h.async=!0;h.src=g[f];n.parentNode.insertBefore(h,n);delete g[f];d(g);l[m]=c})(window,_affirm_config,"affirm","checkout","ui","script","ready");
`;

export function showAffirm({ viewer, item, user, currency }) {
    // Affirm Checkout is enabled
    if (get(viewer, 'affirmEnabled') === false) {
        return false;
    }
    // Not trade user
    if (get(user, 'isVerifiedTrade') === true) {
        return false;
    }
    // Only US IPs
    const countryCode = get(viewer, 'regionalInfo[0].countryCode');
    if (countryCode && countryCode !== US_COUNTRY_CODE) {
        return false;
    }
    // Currency must be USD
    if (currency && currency !== currencies.CURRENCY_USD) {
        return false;
    }
    // Not Suspended or Sold/Unavailable Pdp
    const pdpTypeDisplay = get(item, 'pdpTypeDisplay');
    if (pdpTypeDisplay && pdpTypeDisplay !== 'DEFAULT') {
        return false;
    }

    // Item is eligible
    return !!get(item, 'affirmDisplayInfo.showAffirmPromo');
}
